import React, { useEffect } from 'react'
import { IPageBehaviorComponentProps } from './PageBehaviors'
import MobileCarouselsLegacy from './MobileCarousels-legacy'
import { mq } from 'marketing-site/src/library/utils'
import { NewBrandingHoc } from 'marketing-site/src/library/utils/NewBrandingHoc'

export const MobileCarouselsDefault = ({ children }: IPageBehaviorComponentProps) => {
  useEffect(() => {
    const heroText = document.querySelector('.section--heroWithCta .headline span')
    if (heroText?.innerHTML && heroText?.textContent) {
      heroText.innerHTML = heroText.textContent.replace(
        'best features',
        '<span class="headline--best-features">best <span class="headline--features">features</span></span>',
      )
    }
  })
  return (
    <>
      {children}
      <style jsx global>
        {`
          #layout-wrapper {
            overflow: hidden;
          }

          main {
            overflow: visible;
          }

          .section--carousel h2 {
            max-width: 500px;
            margin: 0 auto;
          }

          .headline--features {
            position: relative;
          }

          @media (${mq.tablet}) {
            .headline--features:after {
              display: none;
            }

            .headline--best-features {
              position: relative;
              white-space: nowrap;
            }
          }

          @media (${mq.desktop}) {
            main {
              padding-top: 40px;
            }

            .section--cardList .card-wrapper {
              margin-left: 20px;
              margin-right: 20px;
            }

            .headline--best-features {
              &:after {
                top: -30px;
                bottom: -40px;
                left: -20px;
                right: -40px;
              }
            }
          }

          @media (${mq.desktopLg}) {
            .section--carousel h2 {
              max-width: 700px;
              margin: 0 auto;
            }
          }
        `}
      </style>
    </>
  )
}

const MobileCarousels = NewBrandingHoc(MobileCarouselsLegacy, MobileCarouselsDefault)
export default MobileCarousels
